import { connect } from 'react-redux';
import {
  getFirstQuestion, showErrors, setUserType, getAnswers, submitSurveyResponses, finishSurvey,
} from '../../actions';
import SurveyPage from './component';

export const mapStateToProps = state => (
  {
    done: state.survey.done,
    name: state.user.name,
    userType: state.user.userType,
    surveyQuestions: state.user.answers,
    displayErrors: state.survey.displayErrors,
  }
);

export default connect(mapStateToProps, {
  getFirstQuestion, showErrors, setUserType, getAnswers, submitSurveyResponses, finishSurvey,
})(SurveyPage);
